<template>
    <div v-if="this.$store.state.orderproperties.CombineShipments == 1">
      <div id="signatureDiv">
        <img id="signatureImage" src="../assets/640x480.png" />
      </div>
      <div>
        <b-list-group-item button id="signButton" variant="success" onClick="tabletDemo()">
          Iniciar captura de Firma
        </b-list-group-item>
        <b-list-group-item button id="saveSignButton" :variant="variantButton" @click="SetSignature()" 
          style="display: none">Guardar Firma</b-list-group-item>
      </div>
    </div>
</template>

<script>
export default {
  name: 'Signature',
  data() {
    return {
      dataSignature: [],
      isEnabledToSendSignature: false,
      variantButton: 'info',
      signature: {
        signatureImage: "",
        docNo: "",
        idVendor: "",
        customerName: ""
      }
    }
  },
  methods: {
    SetSignature() {
      let base64strLength = JSON.stringify(localStorage.getItem('signatureImage')).length
      let base64strWithoutHeader = JSON.stringify(localStorage.getItem('signatureImage')).substring(24, base64strLength-1)

      this.signature.signatureImage = base64strWithoutHeader
      this.signature.docNo = this.printdoc
      this.signature.idVendor = localStorage.getItem('idVendor')
      this.signature.customerName = JSON.parse(localStorage.getItem('AlioPosData')).customer.name

      this.axios.post(this.ApiBaseUrl + 'Signature', 
        JSON.stringify(this.signature), 
        { headers: {"Content-Type": "application/json" }})
        .then((response) => {
          if (response.status == 200) {
            this.isEnabledToSendSignature = false
            
            document.getElementById('saveSignButton').innerHTML = 'Firma Guardada'
            document.getElementById('saveSignButton').classList.add = 'success'
            document.getElementById('signButton').remove()
            
            this.GenPDFSigned()
          }
        })
    },
    GenPDFSigned() {
      this.axios.post(this.ApiBaseUrl + 'PosFunctions/GenSalesShipment',
        JSON.stringify(this.printdoc), { headers: {"Content-Type": "application/json"} })
        .then((response) => {
            if (response.status === 200) {
              this.$store.commit('setIsPrintable', true)
              this.$store.commit('setPrintButtonText', 'Imprimir')
            }
        })
    }
  },
  computed: {
    printdoc() {
      return this.$store.state.printdoc
    }
  }
}
</script>

<style scoped>
.button {
  position:absolute;
}
#signatureBox {
  display: none;
}
#modal-background {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: .50;
  -webkit-opacity: .5;
  -moz-opacity: .5;
  filter: alpha(opacity=50);
  z-index: 1000;
}
#signatureWindow {
  box-shadow: 0 0 20px 0 #222;
  -webkit-box-shadow: 0 0 20px 0 #222;
  -moz-box-shadow: 0 0 20px 0 #222;
  display: none;
  padding: 0;
  position: absolute;
  z-index: 1000;
}
#modal-background.active, #signatureWindow.active {
  display: block;
}
#myCanvas {
  width:100%;
  height:100%;
}
#signatureImage {
  width:465px;
  height:300px;
  border:1px solid black;
  display:block;
}
#wgssSTU {
  width:0;
  height:0;
}
.thirdPartyLicenses {
  display:none;
  font-size:8pt;
}
</style>